import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

/**
 * Filters the items based toggle switch state and filter
 */
@Pipe({
    name: "fromnow"
})
export class FromNowPipe implements PipeTransform {
    transform(dateTime: string): any {
        if (!dateTime) {
            return "";
        }

        const dateTimeNow: any = moment().utc().format("LLL");
        const actionTime: any = moment.utc(dateTime).format("LLL");
        return moment(dateTimeNow).to(actionTime);
    }
}
